let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iqDW3")).then(() => parcelRequire('ev8xC'));